import { FC, ReactNode } from 'react';
import { Box, Pagination, Paper, Skeleton, TableCell, TableContainer, TableRow, Tooltip, Typography } from '@mui/material';
import { Android as AndroidIcon, Apple as AppleIcon, Web as WebIcon } from '@mui/icons-material';
import { DeviceType } from '../../types/user';

// ========== 공용 표시 컴포넌트 ==========

export const DeviceIcon: FC<{ deviceType?: DeviceType | null }> = ({ deviceType }) => {
    switch (deviceType) {
        case DeviceType.ANDROID:
            return <Tooltip title="Android"><AndroidIcon fontSize="small" sx={{ color: '#3DDC84' }} /></Tooltip>;
        case DeviceType.IOS:
            return <Tooltip title="iOS"><AppleIcon fontSize="small" sx={{ color: '#555' }} /></Tooltip>;
        case DeviceType.WEB:
            return <Tooltip title="Web"><WebIcon fontSize="small" sx={{ color: '#1976d2' }} /></Tooltip>;
        default:
            return <Typography variant="caption" color="text.disabled">-</Typography>;
    }
};

export const Row: FC<{ label: string; value: ReactNode }> = ({ label, value }) => (
    <TableRow>
        <TableCell component="th" width="35%" sx={{ verticalAlign: 'middle' }}>{label}</TableCell>
        <TableCell>{value}</TableCell>
    </TableRow>
);

export const KpiCard: FC<{ label: string; value: ReactNode; suffix?: string; extra?: ReactNode }> = ({
    label, value, suffix, extra,
}) => (
    <Paper sx={{ p: 2, height: '100%' }}>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Box display="flex" alignItems="baseline" gap={0.5}>
            <Typography variant="h5" fontWeight={700}>{value}</Typography>
            {suffix && <Typography variant="body2" color="text.secondary">{suffix}</Typography>}
        </Box>
        {extra}
    </Paper>
);

export const KpiInline: FC<{ label: string; value: ReactNode }> = ({ label, value }) => (
    <Box>
        <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
        <Typography variant="body1" fontWeight={600}>{value}</Typography>
    </Box>
);

export const PaginatedSection: FC<{
    loading: boolean;
    empty: boolean;
    emptyText: string;
    page: number;
    totalPages: number;
    onPageChange: (p: number) => void;
    children: ReactNode;
}> = ({ loading, empty, emptyText, page, totalPages, onPageChange, children }) => {
    if (loading) return <Skeleton variant="rectangular" height={200} />;
    if (empty) return <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>{emptyText}</Typography>;
    return (
        <>
            <TableContainer>{children}</TableContainer>
            {totalPages > 1 && (
                <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={totalPages} page={page}
                        onChange={(_, p) => onPageChange(p)} size="small"
                    />
                </Box>
            )}
        </>
    );
};
